import { TabProps } from "@/components/SettingsSidepanel/settings.types.ts";
import { useUserContext } from "@/contexts/UserContextProvider.tsx";
import ChangePasswordForm from "@/components/SettingsSidepanel/Account/ChangePasswordForm";
import EnableMFAForm from "@/components/SettingsSidepanel/Account/EnableMFAForm";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group.tsx";
import { Theme, useTheme, Zoom } from "@/contexts/ThemeContext.tsx";
import DefaultIcon from "@/assets/Default";
import ComfortableIcon from "@/assets/Comfortable";
import CompactIcon from "@/assets/Compact";
import SettingsSheetHeader from "@/components/SettingsSidepanel/SettingsSheetHeader.tsx";
import SettingsProfile from "@/components/SettingsSidepanel/SettingsSheetProfile";
import { Separator } from "@/components/ui/separator.tsx";

const AccountTab: React.FC<TabProps> = ({ onRequestClose }) => {
  const { currentUser } = useUserContext();
  const { theme } = useTheme();
  const { zoom, setZoom } = useTheme();

  return (
    <>
      <SettingsSheetHeader onRequestClose={onRequestClose} title="Account" />

      <div className="space-y-10">
        <div className="flex flex-col gap-4 p-4 rounded-[16px] border border-accent-foreground">
          <SettingsProfile />
          <Separator />
          <div className="flex flex-col gap-3 text-sm">
            <div className="flex flex-col gap-1 text-sm">
              <h5 className="text-lg text-secondary-foreground font-medium">
                Username
              </h5>
              <p className="text-base">{currentUser?.username}</p>
            </div>
            <ChangePasswordForm />
          </div>
          <div className="h-px w-full bg-accent-foreground mt-2" />
          <EnableMFAForm />
        </div>

        <div className="flex flex-col gap-4">
          <h5 className="text-sm text-muted-foreground">Appearance</h5>

          <div className="p-4 rounded-[16px] border border-accent-foreground text-base [&_label]:cursor-pointer">
            <RadioGroup
              className="flex flex-col gap-4 "
              value={zoom}
              defaultValue={zoom}
              onValueChange={(value) => setZoom(value as Zoom)}
            >
              <div className="border p-3 rounded-lg w-full flex justify-between">
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value={Zoom.Default} id="Default" />
                  <label htmlFor="Default">Default</label>
                </div>

                <DefaultIcon
                  color={theme === Theme.Dark ? "#103256" : undefined}
                />
              </div>

              <div className="border p-3 rounded-lg w-full flex justify-between">
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value={Zoom.Comfortable} id="Comfortable" />
                  <label htmlFor="Comfortable">Comfortable</label>
                </div>
                <ComfortableIcon
                  color={theme === Theme.Dark ? "#103256" : undefined}
                />
              </div>

              <div className="border p-3 rounded-lg w-full flex justify-between">
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value={Zoom.Compact} id="Compact" />
                  <label htmlFor="Compact">Compact</label>
                </div>
                <CompactIcon
                  color={theme === Theme.Dark ? "#103256" : undefined}
                />
              </div>
            </RadioGroup>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountTab;
